import { Tooltip, Typography } from "@material-ui/core";
import React, { useCallback } from "react";
import { ErrorRounded } from "@material-ui/icons";

import { makeStyles } from "@material-ui/styles";

import useFeatureFlags from "../../hooks/useFeatureFlag";

import { theme } from "../../theme";

const useStyles = makeStyles((_) => ({
  tooltip: {
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

export function useDuplicateTrackerWarningBackgroundColor() {
  const flags = useFeatureFlags();

  return useCallback(
    (trackerName: string, hoveredTrackerName: string | null) => {
      return flags("unifiedDestinationsUI") &&
        hoveredTrackerName === trackerName
        ? "rgba(255, 255, 0, 0.1)"
        : "inherit";
    },
    [flags]
  );
}

export type DuplicateTrackerWarningIconProps = {
  potentialDuplicateTrackerNames: Set<string>;
  destinationKey: string;
};

function DuplicateTrackerWarningIcon({
  potentialDuplicateTrackerNames,
  destinationKey,
}: DuplicateTrackerWarningIconProps) {
  const classes = useStyles();
  const flags = useFeatureFlags();

  if (
    !flags("unifiedDestinationsUI") ||
    !potentialDuplicateTrackerNames.has(destinationKey)
  ) {
    return null;
  }

  return (
    <Tooltip
      className={classes.tooltip}
      title={
        <Typography variant="body1" style={{ color: "white" }}>
          Warning: this tracker was detected in your Web Tracker Monitoring
          scans, and also appears to be configured as a Freshpaint destination.
          We recommend managing this tracker with Freshpaint if the tracker
          identified in your scans is not the same instance as the one already
          configured as a Freshpaint destination.
        </Typography>
      }
      style={{
        cursor: "pointer",
      }}
    >
      <ErrorRounded
        htmlColor={theme.palette.error.main}
        style={{
          display: "inline-block",
          height: "0.75em",
          marginLeft: "0",
          marginTop: "-0.0625em",
        }}
      />
    </Tooltip>
  );
}

export default DuplicateTrackerWarningIcon;
